import { useSelector, useDispatch } from 'react-redux'
import RalPicker from './../RalPicker'
import { t } from '../../utils/i18n'
import RalPickerUrban from './../RalPickerUrban'
import MinusButton from '../MinusButton'
import PlusButton from '../PlusButton'
import { handleNextColor } from '../Header'
import Modal from '../Modal'
import Popover from '../Popover'
import {
  fullPaintSetRal,
  nextColorClicked,
  bikeImageReload
} from '../../actions'
import { getCustomColorPrice, getColor } from '../../utils/bike-schema'
import { getOrderStatement } from '../../utils/bike-config'

const FullPaintPopover = () => {
  const dispatch = useDispatch()
  const currencyCode = useSelector((state) => state.currencyCode)
  const bikeConfig = useSelector((state) => state.bikeConfig)
  const latestPickedRals = useSelector((state) => state.latestPickedRals)
  const disclaimer = useSelector((state) => state.disclaimer)

  const { baseModelId } = bikeConfig
  const { customColorCount } = getOrderStatement(bikeConfig)
  const customColorPrice = getCustomColorPrice(currencyCode, baseModelId)
  const priceDiffForRal = (ral) => {
    const color = getColor(ral)
    if (customColorCount === 0 && !color.standard) {
      // If no custom color is chosen and this color is not standard, then show `+$xxx`
      return customColorPrice
    } else if (customColorCount > 0 && color.standard) {
      // If at least one custom color is chosen, and this color is standard, then show `-$xxx`
      return -customColorPrice
    } else {
      return 0
    }
  }
  const { choices } = bikeConfig

  if (disclaimer) {
    document.body.classList.remove('dimmed')
    return (
      <Popover
        className="velorbis-customizer-color-picker"
        width={'520px'}
        alignTo={'.velorbis-customizer-header-full-paint'}
      >
        <div className="velorbis-customizer-popover-header full-paint-header">
          {t('full_paint_title')}
          <div className="hide-768 vertical-center">
            <label className="header-next-color-label">
              {t('pick_next_color')}
            </label>
            <PlusButton
              onClick={() =>
                handleNextColor(
                  true,
                  (id) => dispatch(nextColorClicked(id)),
                  () => dispatch(bikeImageReload()),
                  true
                )
              }
            />
            <MinusButton
              onClick={() =>
                handleNextColor(
                  false,
                  (id) => dispatch(nextColorClicked(id)),
                  () => dispatch(bikeImageReload()),
                  true
                )
              }
            />
          </div>
        </div>
        <div className="velorbis-customizer-popover-body velorbis-customizer-popover-body-no-padding">
          {baseModelId.startsWith('urban') ? (
            <RalPickerUrban
              activeRal={choices[baseModelId]}
              priceDiffForRal={priceDiffForRal}
              currencyCode={currencyCode}
              onSelect={(ral) => dispatch(fullPaintSetRal(ral))}
              latestPickedRals={latestPickedRals}
              choices={choices}
              baseModelId={baseModelId}
            />
          ) : (
            <RalPicker
              activeRal={choices[baseModelId]}
              priceDiffForRal={priceDiffForRal}
              currencyCode={currencyCode}
              onSelect={(ral) => dispatch(fullPaintSetRal(ral))}
              latestPickedRals={latestPickedRals}
              choices={choices}
            />
          )}
        </div>
      </Popover>
    )
  } else {
    document.body.classList.add('dimmed')
    return <Modal />
  }
}

export default FullPaintPopover
